module.exports = __webpack_public_path__ + "static/media/en.a5720b9d.svg";